import { z } from "zod";

export const companyProfileSettingsCropFieldDefaultsSchema = z.object({
  potSize: z.string().nullable(),
  pottingWeeks: z.number().nullable(),
});

export type CompanyProfileSettingsCropFieldDefaultsSchema = z.infer<
  typeof companyProfileSettingsCropFieldDefaultsSchema
>;
